import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../../context/AuthContext';

/**
 * Root route element.
 *
 * Hosts any providers that depend on router hooks (e.g. AuthContext's
 * useNavigate). With react-router v6's data router, providers that call
 * useNavigate must live *inside* the router tree, not around
 * <RouterProvider/>, so they sit here on the root route.
 */
export function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
